module.exports = __webpack_public_path__ + "img/microscope.acce28f6.png";